export default "__VITE_ASSET__BnxM1gXi__"